<template>
  <VouchersList />
</template>

<script>
const VouchersList = () => import('@/components/Vouchers/VouchersList')

export default {
  components: {
    VouchersList,
  },

  data() {
    return {}
  },

  computed: {},

  created() { },

  methods: {},
}
</script>

<style lang="scss" scoped></style>
